import { isBaseToken } from "@src/components/DefuseSDK/utils/token"
import { LIST_TOKENS } from "@src/constants/tokens"
import { CURATED_EARN_VAULTS } from "@src/features/earn/lib/constants"
import { isEarnVaultToken } from "@src/features/earn/lib/earnVaultToken"
import type { EarnVaultData, VaultConfig } from "@src/features/earn/lib/types"
import {
  findUnifiedUsdc,
  formatVaultNetwork,
} from "@src/features/earn/lib/utils"

/** Curated, always-visible vaults. Resolved from the token list at runtime. */
export function buildCuratedEarnVaults(
  vaultDataByAssetId: Record<string, EarnVaultData> = {},
  tokenList: typeof LIST_TOKENS = LIST_TOKENS
): VaultConfig[] {
  const paymentToken = findUnifiedUsdc(tokenList)
  if (!paymentToken) return []

  return CURATED_EARN_VAULTS.flatMap((definition) => {
    const vaultToken = tokenList.find(
      (token) =>
        isBaseToken(token) &&
        token.symbol === definition.tokenSymbol &&
        isEarnVaultToken(token)
    )
    if (!vaultToken || !isBaseToken(vaultToken)) return []

    const vaultData = vaultDataByAssetId[vaultToken.defuseAssetId]

    return {
      vaultToken,
      paymentToken,
      apr: vaultData?.apr ?? undefined,
      metadata: {
        vaultId: null,
        rateType: vaultData?.rateType ?? "APY",
        tvlUsd: vaultData?.tvlUsd ?? null,
        providerName: vaultData?.providerName ?? definition.providerLabel,
        poolName: vaultData?.poolName ?? null,
        description: vaultData?.description ?? definition.description,
        documentationUrl: vaultData?.documentationUrl ?? null,
        yieldType: vaultData?.yieldType ?? null,
        network:
          vaultData?.network ??
          formatVaultNetwork(vaultToken.originChainName) ??
          vaultToken.originChainName,
        fee: vaultData?.fee ?? null,
        displayFees: definition.displayFees,
      },
      displayName: definition.displayName,
      shortName: definition.shortName,
      badge: definition.badge,
      description: definition.description,
      minimumDepositUsdc: definition.minimumDepositUsdc,
    }
  })
}
